import React from 'react';
import { Eye, MoreVertical, Pencil, Trash2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';

type ActionRowMenuProps = {
  showView?: boolean;
  canEdit?: boolean;
  onView?: () => void;
  onEdit?: () => void;
  onDelete?: () => void;
};

/** Row kebab for ActionsTable. */
const ActionRowMenu: React.FC<ActionRowMenuProps> = ({
  showView = false,
  canEdit = false,
  onView,
  onEdit,
  onDelete,
}) => (
  <div
    className="dropdown-actions"
    onClick={(event) => event.stopPropagation()}
  >
    <DropdownMenu>
      <DropdownMenuTrigger
        render={
          <Button
            type="button"
            variant="ghost"
            size="icon-sm"
            aria-label="Action options"
          />
        }
      >
        <MoreVertical className="tw:size-4" />
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="end"
        className="dark"
        onClick={(event) => event.stopPropagation()}
      >
        {showView && onView ? (
          <DropdownMenuItem onClick={onView}>
            <Eye />
            View
          </DropdownMenuItem>
        ) : null}
        {canEdit ? (
          <>
            {onEdit ? (
              <DropdownMenuItem onClick={onEdit}>
                <Pencil />
                Edit
              </DropdownMenuItem>
            ) : null}
            {onDelete ? (
              <DropdownMenuItem variant="destructive" onClick={onDelete}>
                <Trash2 />
                Delete
              </DropdownMenuItem>
            ) : null}
          </>
        ) : null}
      </DropdownMenuContent>
    </DropdownMenu>
  </div>
);

export default ActionRowMenu;
